import {GenericService} from '@/shared/xhttp';
import {DocumentProprietaire} from "@/models/DocumentProprietaire";

export class DocumentProprietaireService extends GenericService<DocumentProprietaire> {
}